"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redactEvent = redactEvent;
exports.redactBreadcrumb = redactBreadcrumb;
const sensitiveData_1 = require("./sensitiveData");
const isRecord = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
const redactValue = (value) => {
    if (typeof value === 'string')
        return (0, sensitiveData_1.redactSensitiveValuesInText)(value);
    if (Array.isArray(value))
        return value.map(redactValue);
    if (isRecord(value)) {
        return Object.fromEntries(Object.entries(value).map(([key, nested]) => [key, (0, sensitiveData_1.isSensitiveKey)(key) ? sensitiveData_1.REDACTED_VALUE : redactValue(nested)]));
    }
    return value;
};
const redactStringRecord = (record) => Object.fromEntries(Object.entries(record).map(([key, value]) => [
    key,
    (0, sensitiveData_1.isSensitiveKey)(key) ? sensitiveData_1.REDACTED_VALUE : (0, sensitiveData_1.redactSensitiveValuesInText)(value),
]));
const redactCookies = (cookies) => Object.fromEntries(Object.keys(cookies).map(name => [name, sensitiveData_1.REDACTED_VALUE]));
const redactQueryParams = (query) => {
    if (typeof query === 'string')
        return (0, sensitiveData_1.redactSensitiveValuesInText)(query);
    if (Array.isArray(query)) {
        return query.map(([key, value]) => [key, (0, sensitiveData_1.isSensitiveKey)(key) ? sensitiveData_1.REDACTED_VALUE : value]);
    }
    return redactStringRecord(query);
};
const redactException = (exception) => ({
    ...exception,
    values: exception.values?.map(value => value.value === undefined ? value : { ...value, value: (0, sensitiveData_1.redactSensitiveValuesInText)(value.value) }),
});
function redactEvent(event) {
    const { request, exception } = event;
    const redactedEvent = exception?.values ? { ...event, exception: redactException(exception) } : event;
    if (!request)
        return redactedEvent;
    const redactedRequest = { ...request };
    if (request.url)
        redactedRequest.url = (0, sensitiveData_1.redactSensitiveValuesInText)(request.url);
    if (request.headers)
        redactedRequest.headers = redactStringRecord(request.headers);
    if (request.cookies)
        redactedRequest.cookies = redactCookies(request.cookies);
    if (request.query_string)
        redactedRequest.query_string = redactQueryParams(request.query_string);
    if (request.data !== undefined)
        redactedRequest.data = redactValue(request.data);
    return { ...redactedEvent, request: redactedRequest };
}
function redactBreadcrumb(breadcrumb) {
    if (!breadcrumb.data)
        return breadcrumb;
    const data = { ...breadcrumb.data };
    delete data['http.query'];
    if (typeof data.url === 'string')
        data.url = (0, sensitiveData_1.redactSensitiveValuesInText)(data.url);
    return { ...breadcrumb, data };
}
